module.exports = __webpack_public_path__ + "img/Aﬃn Max.ff9b74a5.png";